import React, { Fragment, useState, useEffect } from 'react';
import SingleSelect from '../../common/Forms/SingleSelect';
import axios from 'axios';

const MailgunInfo = ({ domainFormOptions, initialDomain, initialTemplate, domainFormName = 'campaign[mailgun_domain]', templateFormName = 'campaign[template]'}) => {
  const [domain, setDomain] = useState(initialDomain);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(initialTemplate);
  // Why the list is empty, when it is -- see the warning rendered below.
  const [catalogueError, setCatalogueError] = useState(null);
  // True when what arrived is Mailgun's first page, not the whole catalogue.
  const [cataloguePartial, setCataloguePartial] = useState(false);

  useEffect(() => {
    if (!domain) return;

    // An unreadable catalogue used to look exactly like a domain with no
    // templates: an empty dropdown and nothing else. This control showed "No
    // options" for days from 2026-10-09 while Mailgun answered `400 Bad
    // Request` to an out-of-range `limit` -- a reason that reached the logs and
    // no screen, and that was mistaken for a dead API key. Show it.
    axios.get(`/admin/campaigns/templates?mailgun_domain=${domain.value}`)
      .then((res) => {
        setCatalogueError(res.data.error || null);
        setCataloguePartial(Boolean(res.data.partial));
        setTemplates((res.data.templates || []).map((t) => ({ label: t, value: t })));
      })
      .catch((e) => {
        setCatalogueError(e.message || 'request failed');
        setCataloguePartial(false);
        setTemplates([]);
      })
  }, [domain])

  const handleChange = (options) => {
    setDomain(options);
    setSelectedTemplate();
  };

  const handleTemplateChange = (options) => {
    setSelectedTemplate(options);
  }

  return (
    <Fragment>
      <label>
        Mailgun Domain
      </label>
      <input name={domainFormName}
             value={domain && domain.value}
             hidden />
      <SingleSelect
        handleChange={handleChange}
        options={domainFormOptions}
        selectedValue={domain}
        placeholderText='Select Mailgun Domain'
      />

      <br />
      <label>
        Mailgun Template
      </label>
      <input name={templateFormName}
             value={selectedTemplate && selectedTemplate.value}
             hidden />
      <SingleSelect
        skipDefault
        handleChange={handleTemplateChange}
        options={templates}
        selectedValue={selectedTemplate}
        placeholderText='Select Mailgun Template'
      />
      {catalogueError && (
        <p className="help-block" style={{ color: '#a94442', marginTop: '6px' }}>
          <strong>
            {cataloguePartial
              ? 'Mailgun template list incomplete'
              : 'Mailgun template list unavailable'}
          </strong>
          {' '}
          {cataloguePartial
            ? `— Mailgun refused the full request, so only its first page of
               templates is listed. A template you expect and cannot find here
               does exist; it just did not load.`
            : `— this is not an empty Mailgun account. The template list could
               not be read, so nothing can be picked here until it is fixed.`}
          <br />
          <small>{catalogueError}</small>
        </p>
      )}
    </Fragment>
  );
};

export default MailgunInfo;
